import Joi from 'joi';
const yourInteriorsBlockSchema = Joi.object({
  type: Joi.string().valid('yourInteriorsBlock').required(),
  code: Joi.string().allow('', null).optional(),
  title: Joi.string().allow('', null).optional(),
  titleLink: Joi.string().allow('', null).optional(),
  backgroundColor: Joi.string().allow('', null).optional(),
  images: Joi.array().items(Joi.object({
    id: Joi.string().required(),
    src: Joi.string().required(),
    alt: Joi.string().allow('', null).optional(),
    href: Joi.string().allow('', null).optional()
  }).unknown(true)).required()
}).unknown(true);
export default yourInteriorsBlockSchema;